// extracted by mini-css-extract-plugin
module.exports = {"item":"Item_item__3KFdz","stackSize":"Item_stackSize__o5pzS","icon":"Item_icon__3NX0P"};